import { useEffect, useState, useMemo } from 'react'
import { isNumber, sumBy } from 'lodash';
import { useFetch } from 'hooks'
import { Button, NoRecord, Table, Popup, Textbox, ButtonRow, SelectMenu, Docker, Filter } from 'components/generic';
import { getValueById, getValuesById, requestValidator } from 'utils';
import { useSelector } from 'react-redux';
import Images from 'assets/Images';
import { AnimatePresence, motion } from 'framer-motion';
import './style.scss';

const UserManagement = () => {
    const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const api = useFetch();
    const referenceData = useSelector(state => state?.referenceData?.data);

    const [selectedUser, setSelectedUser] = useState(null);
    const [createObj, setCreateObj] = useState({});
    const [tableDataCount, setTableDataCount] = useState(0);
    const [countryCodes, setCountryCodes] = useState(null);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [tableWidth, setTableWidth] = useState();
    const [tableData, setTableData] = useState('');
    const [scrollToTop, setScrollToTop] = useState(0);
    const [scrollbarEnable, setScrollbarEnable] = useState(false);
    const [tablePayload, setTablePayload] = useState({ start_index: 0, record_count: 20 });
    const [userValidation, setUserValidation] = useState(false);
    const [popupState, setPopupState] = useState(null);

    const [addPopupToggler, setAddPopupToggler] = useState(null);

    useEffect(() => {
        gridStructure();
        tableDataAPI({ start_index: 0, record_count: 20 });
    }, []);

    const gridStructure = async () => {
        const { data } = await api({ url: 'gridStructure/v1/USER_MANAGEMENT', method: 'get' });
        setTableWidth(`${sumBy(data?.data[0]?.columns, 'columnWidth')}px`);
        setTableHeaders(data?.data[0]?.columns);
    };

    const dataHandler = (e, key) => {
        key === 'country' && countryCodes?.countryList?.find(el => el?.key === e && setCountryCodes(prevState => ({ ...prevState, selectedCountry: el })));
        setCreateObj(prevState => ({ ...prevState, [key]: e }));
    };

    const handleNewButton = () => {
        setCreateObj({});
        setSelectedUser(null);
        setAddPopupToggler(true);
        !countryCodes && setCountryCodes({ countryList: getValueById(referenceData, 'rd_countryCodes')?.value });
    };

    const setPayload = (payload, reset) => {
        setTablePayload(prevState => {
            const data = { ...prevState, ...payload, start_index: payload.incStartIndex ? prevState?.start_index + 20 : 0, record_count: 20 };
            tableDataAPI(data, reset);
            setScrollToTop(reset);
            return data;
        });
    };

    const tableDataAPI = async (payload, reset) => {
        const apiReq = { filter: payload?.filter, sort: payload?.sort || null, start_index: reset ? 0 : payload?.start_index || 0, record_count: 20 };
        const { data } = await api({ url: 'client/v1/listUser', method: 'post', data: apiReq });
        const elm = data?.data?.at();
        const tableData = elm?.results;
        if (tableData?.length) {
            setTableData(prevState => (reset ? elm?.results : [...new Set([...prevState, ...tableData])]));
            setScrollbarEnable(elm?.results?.length);
        }
        setTableDataCount(elm?.total || 0);
    };

    const handleFilter = e => {
        setPayload({ filter: e }, true);
    };

    const handleSort = e => {
        setPayload({ sort: [e] }, true);
    };

    const handleScroll = (e) => {
        e !== 20 && setPayload({ incStartIndex: true }, false);
    };

    const handleCheckbox = value => {
        setSelectedUser(value);
    };

    const reset = () => {
        setSelectedUser(null);
        setCreateObj({});
        setAddPopupToggler(null);
        setPopupState(null);
        setUserValidation(false);
    }

    const handleButtonClick = e => {
        if (e === 'Create' || e === 'Save') checkUser()
        else if (e === 'Goback') reset();
        else setAddPopupToggler(false);
    };

    // validation for signup
    useEffect(() => {
        setUserValidation(requestValidator({ ...createObj, validatorKey: createObj?.edit ? 'userManagementEdit' : 'userManagement' }));
    }, [createObj]);

    // password & email validation 
    const checkUser = () => {
        const emailValid = emailValidationRegex.test(createObj?.email);
        console.log('password', createObj?.password);
        console.log('re', createObj?.rePassword)
        const passwordValid = createObj?.password === createObj?.rePassword
        const errorMsg = !emailValid ? 'The email format is not valid.' : !passwordValid ? 'Password does not match' : null;
        setCreateObj(prevState => ({ ...prevState, errorMsg }));
        emailValid && passwordValid && (createObj?.edit ? handleEditUser() : handleCreateUser());
    };

    // toaster message for errors
    const toaster = createObj?.errorMsg && (
        <div className='user__error'>
            <img src={Images?.error_alert} />
            <span>{createObj?.errorMsg}</span>
        </div>
    );

    const handleCreateUser = async () => {
        const data = { first_name: createObj?.first_name, last_name: createObj?.last_name, user_name: `${createObj?.user_name}_${localStorage.getItem('c_id')}`, mobile: createObj?.mobile, mobile_prefix: countryCodes?.selectedCountry?.phone_code, email: createObj?.email, password: createObj?.password };
        await api({ url: 'client/v1/addUser', method: 'post', data, successToaster: true });
        tableDataAPI({}, true);
        reset();
    }

    const handleEditUser = async () => {
        console.log('Edit User', createObj)
        const data = { first_name: createObj?.first_name, last_name: createObj?.last_name, mobile: createObj?.mobile, mobile_prefix: countryCodes?.selectedCountry?.phone_code, password: createObj?.password, email: createObj?.email, user_name: `${createObj?.user_name}_${localStorage.getItem('c_id')}`, user_id: createObj?.user_id };
        await api({ url: 'client/v1/editUser', method: 'post', data, successToaster: true });
        tableDataAPI({}, true);
        reset();
    }

    const handleDocker = e => {
        !countryCodes && setCountryCodes({ countryList: getValueById(referenceData, 'rd_countryCodes')?.value });
        e?.key === 'cancel' && setSelectedUser(null);
        e?.key === 'edit' && editUser();
    };

    const editUser = async () => {
        const { data } = await api({ url: `client/v1/user/${tableData?.[selectedUser]?.user_id}`, method: 'get' });
        const userDetails = data?.data;
        userDetails.user_name = userDetails?.user_name?.split('_')?.at();
        const country = countryCodes?.countryList?.find(elm => elm.phone_code === userDetails?.mobile_prefix);
        userDetails.country = country?.key;
        userDetails.password = '';
        userDetails.rePassword = '';
        setCountryCodes(prevState => ({ ...prevState, selectedCountry: country }));
        setCreateObj({ ...data?.data, edit: true });
        setAddPopupToggler(true);
    }

    const handleEnableDisableUser = async () => {
        const data = { user_id: createObj?.user_id, user_status: createObj?.user_status };
        await api({ url: 'client/v1/deleteUser', method: 'patch', data, successToaster: true });
        tableDataAPI({}, true);
        reset();
    }

    const handleToggle = (e, user) => {
        user.user_status = e;
        setCreateObj(user);
        setPopupState(true);
    }

    const handleEnableUserPopup = e => {
        if (e === 'Yes') handleEnableDisableUser();
        else setPopupState(null);
    }

    // popup content for enable/disable user
    const enableUserPopupContent = useMemo(
        () => (
            <Popup onClose={() => setPopupState(null)} popupState={popupState}>
                <div className='bim__confirmation'>
                    <img src={Images.warningPopup} alt='warning' />
                    <h3>Warning</h3>
                    <p> {`Are you sure you want to ${createObj?.user_status ? 'Enable' : 'Disable'}?`}</p>
                    <ButtonRow label='No' label1='Yes' handleButtonClick={e => handleEnableUserPopup(e)} />
                </div>
            </Popup>
        ),
        [popupState]
    );

    const createPopupContent = useMemo(() => {
        return (
            <Popup onClose={reset} popupState={addPopupToggler}>
                <div className='user__popup'>
                    <h3>{createObj?.edit ? 'Edit' : 'Create'} User</h3>
                    {toaster}
                    <div className='row'>
                        <div className='col-6'>
                            <Textbox label='First Name' infoContent='Enter First Name' mandatory placeholder='Enter First Name' value={createObj?.first_name} onChange={e => dataHandler(e?.target?.value, 'first_name')} />
                        </div>
                        <div className='col-6'>
                            <Textbox label='Last Name' infoContent='Enter Last Name' mandatory placeholder='Enter Last Name' value={createObj?.last_name} onChange={e => dataHandler(e?.target?.value, 'last_name')} />
                        </div>
                        <div className='col-6'>
                            <SelectMenu label='Country' mandatory infoContent='Select the country' menuOptions={countryCodes?.countryList || []} placeholder='Select' value={getValuesById(countryCodes?.countryList, createObj?.country)} onChange={e => dataHandler(e, 'country')} />
                        </div>
                        <div className='col-6'>
                            <Textbox type='number' mandatory label='Mobile Number' infoContent='Enter Mobile Number' placeholder='Enter Mobile Number' prefix={countryCodes?.selectedCountry?.phone_code} prefixValue={countryCodes?.selectedCountry?.phone_code} onChange={e => dataHandler(e?.target?.value, 'mobile')} value={createObj?.mobile} />
                        </div>
                        <div className='col-6'>
                            <Textbox type='email' label='Email' mandatory infoContent='Enter Email' placeholder='Enter Email ID' disabled={createObj?.edit} value={createObj?.email} onChange={e => dataHandler(e?.target?.value, 'email')} />
                        </div>
                        <div className='col-6'>
                            <Textbox mandatory label='Username' placeholder='Enter username' infoContent='Enter username' disabled={createObj?.edit} value={createObj?.user_name} suffix={true} suffixValue={`_${localStorage.getItem('c_id')}`} onChange={e => dataHandler(e?.target?.value, 'user_name')} />
                        </div>
                        <div className='col-6'>
                            <Textbox type='password' mandatory={!createObj?.edit} label='Password' placeholder='Enter Password' infoContent='Enter Password' maxlength={16} onChange={e => dataHandler(e?.target?.value, 'password')} value={createObj?.password} />
                        </div>
                        <div className='col-6'>
                            <Textbox type='password' mandatory={!createObj?.edit} label='Re-enter Password' placeholder='Re-enter Password' infoContent='Re-enter Password' maxlength={16} onChange={e => dataHandler(e?.target?.value, 'rePassword')} value={createObj?.rePassword} />
                        </div>
                    </div>
                    <ButtonRow label='Goback' label1={createObj?.edit ? 'Save' : 'Create'} right disableSave={userValidation} handleButtonClick={handleButtonClick}></ButtonRow>
                </div>
            </Popup>
        );
    }, [addPopupToggler, createObj]);

    return <>
        <div className='user__container'>
            <div className='user__add flex-end'>
                <Filter filterObj={tableHeaders?.filter(el => el?.filterBy)} handleSubmit={handleFilter} />
                <Button primary compact label='add new' handleOnSubmit={handleNewButton} />
            </div>
            {tableDataCount > 0 && (
                <>
                    <div className='user__display'>
                        <Table
                            handleToggle={(e, user) => handleToggle(e, user)}
                            hideHeaderCheckbox
                            checkboxWidth='60px'
                            checkboxDisabled={{ allow: true, key: 'enabled' }}
                            checkedItem={selectedUser}
                            tableHeader={tableHeaders}
                            tableData={tableData}
                            tableCount={tableDataCount}
                            scrollToTop={scrollToTop}
                            tableWidth={tableWidth}
                            handleSort={handleSort}
                            infiniteScroll={scrollbarEnable}
                            handleScroll={handleScroll}
                            onCheckboxClick={handleCheckbox}
                        />
                    </div>
                    <p className='user_count'>Total records {tableDataCount}</p>
                </>
            )}
            {!tableDataCount && <NoRecord header='No Users found!' description='Please add new User!' />}
        </div>
        {createPopupContent}
        <AnimatePresence mode='wait'>
            {isNumber(selectedUser) && (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
                    <Docker dockerClick={handleDocker} dockerlist={['edit']} selectlist={[selectedUser]} />
                </motion.div>
            )}
        </AnimatePresence>
        {enableUserPopupContent}
    </>
}


export default UserManagement;